import { Component, OnInit, Input, AfterViewInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DefaultService } from "src/app/services/default/default.service";

import { CustomTable } from "src/app/models/custom-table-model";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CustomPage } from "src/app/models/custom-page-model";
import { NgxSpinnerService } from "ngx-spinner";
import { DateFormatterService } from "src/app/services/date-formatter/date-formatter.service";
import { CustomButton } from "src/app/models/custom-button-model";
import { Location } from "@angular/common";
import { Webflow } from "src/app/utils/webflow";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-custom-table",
  templateUrl: "./custom-table.component.html",
  styleUrls: ["./custom-table.component.scss"],
})
export class CustomTableComponent implements OnInit {
  @Input() custom_page: CustomPage;
  @Input() custom_buttons: Array<any> = [];
  @Input() columns: Array<any> = [];
  @Input() show_title: boolean = true;
  @Input() show_search_input: boolean = true;
  @Input() show_pagination: boolean = true;
  @Input() show_add_button: boolean = true;
  @Input() show_delete_button: boolean = true;
  @Input() show_edit_button: boolean = true;
  @Input() visible_actions: Array<any> = [];
  @Input() invisible_actions: Array<any> = [];
  @Input() multi_actions: Array<any> = [];
  @Input() actions_with_condition: Array<any> = [];
  @Input() index: string = "id";
  @Input() show_back_button: boolean = false;
  @Input() sub_title: string = "";

  searchForm: FormGroup;
  loading: boolean = true;
  query: string = "";
  customTable: CustomTable;
  limit: number = 10;
  count_items: number = 0;
  current_page: number = 1;
  nbr_pages: number = 1;
  results: Array<any> = [];
  pageNums: Array<number> = [];

  constructor(
    private location: Location,
    private spinner: NgxSpinnerService,
    private router: Router,
    private defaultService: DefaultService,
    private activatedRoute: ActivatedRoute,
    private formBuilder: FormBuilder
  ) {
    this.searchForm = this.formBuilder.group({
      searchInput: ["", [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.show_back_button = params.show ? true : this.show_back_button;
      this.show_add_button = params.hide ? false : this.show_add_button;

      this.show_loading();
      this.current_page = params["page"] ? params["page"] : 1;
      this.limit = params["limit"] ? params["limit"] : this.limit;
      if (params["q"]) {
        this.query = params["q"];
        this.searchForm.patchValue({ searchInput: this.query });
      } else {
        this.query = "";
        this.searchForm.patchValue({ searchInput: this.query });
      }

      let selected_filters =
        params.filters != undefined && params.filters != ""
          ? params.filters
          : "";

      let selected_values =
        params.value_field != undefined && params.value_field != ""
          ? params.value_field
          : "";
      let filters_generated = this.generate_filters(
        selected_filters,
        selected_values
      );

      this.get_results(filters_generated);
      this.selectedOptionsList(params);
    });
  }

  selectedOptionsList(params: any) {
    this.columns
      .filter((element) => {
        return (
          element.type == "enum" || element.type == "relation-list-with-filter"
        );
      })
      .forEach((item) => {
        let key_field =
          params.key_field != undefined && params.key_field != ""
            ? params.key_field
            : "";
        let value_field =
          params.value_field != undefined ? params.value_field : "";
        item.selected = item.key == key_field ? value_field : "";
      });
    Webflow.setIFrameHeight();
  }

  generate_filters(filters: string, value: any) {
    let str = "";
    if (filters != "") {
      let array = filters.split(".");
      str += "&filters";
      array.forEach((item) => {
        str += "[" + item + "]";
      });
      str += "=" + value;
    }

    return str;
  }

  get_results(custom_filter: string) {
    this.spinner.show();
    let filters = (this.query != "" ? "&_q=" + this.query : "") + custom_filter;
    let selected_route =
      this.custom_page.endpoint + this.custom_page.custom_route;

    this.activatedRoute.queryParams.subscribe((params) => {
      if (
        params.order_by != undefined &&
        params.order_by != "" &&
        params.order_by != null &&
        params.order_by_option != undefined &&
        params.order_by_option != "" &&
        params.order_by_option != null
      ) {
        const index = this.columns.findIndex(
          (column) => column.key === params.order_by
        );

        if (index !== -1) {
          this.columns[index].order_by_option =
            params.order_by_option == "desc" ? "asc" : "desc";
        }
        this.custom_page.filters +=
          "&sort[0]=" + params.order_by + ":" + params.order_by_option;
      } else {
        this.custom_page.filters += "&sort[0]=createdAt%3Adesc";
      }
    });

    this.defaultService
      .get_light(
        selected_route,
        this.limit,
        this.current_page,
        this.show_pagination,
        this.custom_page.filters,
        filters
      )
      .subscribe(
        (res: any) => {
          if (Array.isArray(res)) {
            this.results = res;
          } else {
            this.customTable = new CustomTable(this.custom_page.endpoint);
            let data_from_api = res.data;
            this.results = this.customTable.get_array_data(data_from_api);
            if (this.show_pagination) {
              this.count_items = res.meta.pagination.total;
              this.nbr_pages = res.meta.pagination.pageCount;
              this.generate_paginations();
            }
          }
          setTimeout(() => {
            Webflow.setIFrameHeight();
          }, 500);
        },
        (err) => {
          Webflow.setIFrameHeight();
          this.results = [];
        }
      )
      .add(() => {
        this.loading = false;
        this.spinner.hide();
      });
  }

  generate_paginations() {
    this.pageNums = [];
    if (this.nbr_pages <= 5) {
      for (let i = 1; i <= this.nbr_pages; i++) {
        this.pageNums.push(i);
      }
    } else {
      let page = Number.parseInt(this.current_page.toString());
      if (page < 3) {
        for (let i = 1; i <= 3; i++) {
          this.pageNums.push(i);
        }
        this.pageNums.push(NaN);
        this.pageNums.push(this.nbr_pages);
      } else {
        this.pageNums.push(1);
        if (page != 3) {
          this.pageNums.push(NaN);
        }
        let numBefore = page - 1;
        let numAfter = page + 1;
        if (page == this.nbr_pages) {
          for (let i = numBefore - 1; i <= this.nbr_pages; i++) {
            this.pageNums.push(i);
          }
        } else {
          for (let i = numBefore; i <= numAfter; i++) {
            this.pageNums.push(i);
          }
          if (page == this.nbr_pages - 2) {
            this.pageNums.push(this.nbr_pages);
          } else if (page != this.nbr_pages - 1) {
            this.pageNums.push(NaN);
          }
        }
      }
    }
  }

  do_search() {
    Webflow.myAction(this.router,this.custom_page.endpoint,{ q: this.f.searchInput.value });
  }

  checkIsNumber(page: any) {
    if (Number.isNaN(page)) {
      return false;
    } else {
      return true;
    }
  }

  go_to_page(routerLink: string,queryParams: any) {
    Webflow.myAction(this.router,routerLink,queryParams);
  }

  next() {
    return this.current_page == this.nbr_pages
      ? this.nbr_pages
      : Number(this.current_page) + 1;
  }

  previous() {
    return this.current_page == 1 ? 1 : Number(this.current_page) - 1;
  }

  show_loading() {
    this.results = [];
    this.loading = true;
  }

  generate_route_query(page: number) {
    let query_params = {};
    if (this.query != "") {
      query_params["q"] = this.query;
    }

    this.activatedRoute.queryParams.subscribe((params) => {
      Object.entries(params).forEach(([key, value]) => {
        query_params[key] = value;
      });
    });

    query_params["page"] = page;
    query_params["limit"] = this.limit;

    return query_params;
  }

  get f() {
    return this.searchForm.controls;
  }

  change_limit(limit: any) {
    let query_params = {};
    if (this.query != "") {
      query_params["q"] = this.query;
    }

    this.activatedRoute.queryParams.subscribe((params) => {
      Object.entries(params).forEach(([key, value]) => {
        query_params[key] = value;
      });
    });

    query_params["page"] = 1;
    query_params["limit"] = limit;
    Webflow.myAction(this.router,this.custom_page.endpoint,query_params);
  }

  change_filters(element: any, event: any) {
    //let selected_route = this.custom_page.endpoint + this.custom_page.custom_route;
    let selected_route = this.custom_page.endpoint;

    let params_query = {
      page: 1,
      limit: this.limit,
    };

    this.activatedRoute.queryParams.subscribe((params) => {
      Object.entries(params).forEach(([key, value]) => {
        params_query[key] = value;
      });
    });

    if (event.target.value == "") {
      delete params_query["filters"];
      delete params_query["key_field"];
      delete params_query["value_field"];
      Webflow.myAction(this.router,selected_route, params_query);
    } else {
      if (element.type == "relation-list-with-filter") {
        params_query["filters"] = element.key + "." + element.text;
        params_query["key_field"] = element.key;
        params_query["value_field"] = event.target.value;
        Webflow.myAction(this.router,selected_route, params_query);
      } else {
        if (
          element.custom_filters != undefined &&
          element.custom_filters != null &&
          element.custom_filters
        ) {
          params_query["filters"] = element.custom_filters;
          params_query["key_field"] = element.key;
          params_query["value_field"] = event.target.value;
          Webflow.myAction(this.router,selected_route, params_query);
        } else {
          params_query["filters"] = element.key;
          params_query["key_field"] = element.key;
          params_query["value_field"] = event.target.value;
          Webflow.myAction(this.router,selected_route, params_query);
        }
      }
    }
  }

  back() {
    this.location.back();
  }

  setBgRowTable(item: any) {
    let is_deleted: boolean =
      item["user"] != null && item["user"] != undefined
        ? item["user"]["is_deleted"] != null &&
          item["user"]["is_deleted"] != undefined
          ? item["user"]["is_deleted"]
            ? true
            : false
          : false
        : false;
    let styles = {
      "background-color": is_deleted ? "rgb(255 228 228)" : "#ffffff",
    };
    return styles;
  }

  redirectTo(uri: string, params: any) {
    this.router
      .navigateByUrl("/", { skipLocationChange: false })
      .then(() => this.router.navigate([uri], { queryParams: params }));
  }

  actionCustomButtons(item_button: any) {
    if (item_button.route != undefined && item_button.action == undefined) {
      Webflow.myAction(this.router,item_button.route, {});
    }

    if (item_button.route == undefined && item_button.action != undefined) {
      item_button.action();
    }
  }

  check_order_by(element: any) {
    return (
      element.order_by != null &&
      element.order_by != undefined &&
      element.order_by === true
    );
  }

  click_filter(element: any) {
    let selected_route = this.custom_page.endpoint;
    let params_query = {
      page: 1,
      limit: this.limit,
    };

    this.activatedRoute.queryParams.subscribe((params) => {
      Object.entries(params).forEach(([key, value]) => {
        params_query[key] = value;
      });
    });

    params_query["order_by"] = element.key;
    params_query["order_by_option"] = element.order_by_option;

    Webflow.myAction(this.router,selected_route, params_query);
  }

}
